import WeaToolIntro from "./intro"

window.WeaToolIntro = WeaToolIntro;

export default WeaToolIntro;